const blockers = new Set();

export const registerReminderPromptBlocker = (key) => {
  blockers.add(key);
  return () => {
    blockers.delete(key);
  };
};

export const isReminderPromptBlocked = () => blockers.size > 0;
